import React, { memo } from 'react';
import styled from 'styled-components';
import { CommonConstant } from '../../constant/CommonConstant';
import AddressHeaderField from './AddressHeaderField';

const AddressHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const AddressHeaderContainer = memo(() => {
  return (
    <AddressHeaderWrapper>
      {CommonConstant.CompanyInfo.map((item, index) => (
        <AddressHeaderField
          showBorder={index !== CommonConstant.CompanyInfo.length - 1}
          title={item.title}
          content={item.content}
          key={item.id}
        />
      ))}
    </AddressHeaderWrapper>
  );
});

export default AddressHeaderContainer;
